import debounce from 'lodash/debounce';

// password strength should be a number from 0 - 4 with 0 being the worst
// map the strength to the width of the progress bar (%) and its colour
const STRENGTH_TO_WIDTH = [ 100, 25, 50, 75, 100 ];
const STRENGTH_TO_COLOUR = [ 'bg-danger', 'bg-danger', 'bg-warning', 'bg-warning', 'bg-success' ];
const STRENGTH_TO_TEXT = [
    'A different password would be more secure',
    'Password should be stronger',
    'Password could be stronger',
    'Good - strong password',
    'Brilliant - very strong password',
];

export default function(passwordStrengthMeters: NodeList): void {
    const html: string = '<div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="4"></div></div><small class="help"></small>';

    for (let i = 0; i < passwordStrengthMeters.length; i++) {
        const container = passwordStrengthMeters[i] as HTMLDivElement;
        if (typeof container.dataset.passwordSource !== 'string') {
            continue;
        }

        const passwordSource = document.querySelector(container.dataset.passwordSource);
        if (passwordSource === null) {
            continue;
        }

        // set up html
        container.innerHTML = html;
        const progressBar = container.querySelector('.progress-bar') as HTMLDivElement;
        const helpText = container.querySelector('.help') as HTMLElement;

        // set up listener
        passwordSource.addEventListener('input', debounce((evt) => {
            const enteredPassword = evt.target.value;

            if (typeof enteredPassword !== 'string' || enteredPassword === '') {
                // clear progress bar
                progressBar.style.width = '0';
                return;
            }

            // set progress bar animating
            progressBar.style.width = '100%';
            progressBar.classList.remove(...STRENGTH_TO_COLOUR);
            progressBar.classList.add('bg-dark', 'progress-bar-animated', 'progress-bar-striped');
            progressBar.setAttribute('aria-valuenow', '0');
            helpText.innerText = '';

            const fd = new FormData();
            fd.append('password', enteredPassword);

            fetch('/password-strength', {
                method: 'POST',
                credentials: 'same-origin',
                body: fd,
            }).then(resp => {
                if (resp.status !== 200) {
                    throw 'Could not get password strength';
                }

                return resp.text();
            }).then(respText => {
                // update progress bar
                const strength = parseInt(respText, 10);
                if (strength < 0 || strength > 4) {
                    throw 'Invalid strength';
                }

                progressBar.style.width = STRENGTH_TO_WIDTH[strength] + '%';
                progressBar.classList.remove('bg-dark', 'progress-bar-animated', 'progress-bar-striped');
                progressBar.classList.add(STRENGTH_TO_COLOUR[strength]);
                progressBar.setAttribute('aria-valuenow', strength.toString());
                helpText.innerText = STRENGTH_TO_TEXT[strength];
            });
        }, 500));
    }
}
